import { combineReducers } from 'redux';
import { ActionType, getType } from 'typesafe-actions';

import * as language from './actions';

export interface ILanguageState {
  readonly primary: boolean;
}

export type LanguageAction = ActionType<typeof language>;

const initialState: ILanguageState = {
  primary: true
};

export default combineReducers<ILanguageState, LanguageAction>({
  primary: (state: boolean = initialState.primary, action) => {
    switch (action.type) {
      case getType(language.toggle): {
        return action.payload;
      }
      default: {
        return state;
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/modules/language/reducer.ts